import { render, staticRenderFns } from "./SocialStatuses.vue?vue&type=template&id=7f98279c&"
import script from "./SocialStatuses.vue?vue&type=script&lang=js&"
export * from "./SocialStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports